import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

const token = document.head.querySelector('meta[name="csrf-token"]');
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

if (token) {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

axios.interceptors.response.use(response => response, (error) => {
  if (Vue.$router.currentRoute.meta.handle === false) {
    return Promise.reject(error);
  }
  switch (error.response.status) {
    case 401:
      if (Vue.$router.currentRoute.meta.auth) {
        Vue.toasted.show('Session expired.', { type: 'error' });
        Vue.$router.replace({ name: 'login' });
      }
      break;
    case 403:
      Vue.$router.replace('/403');
      break;
    case 422:
      Vue.toasted.show('Validated filed', { type: 'error' });
      return Promise.reject(error);
    case 429:
      Vue.toasted.show('Too many requests', { type: 'error' });
      return;
    case 400:
    case 405:
    case 500:
      Vue.toasted.show(error.response.data.error.message, { type: 'error' });
      break;
  }
  return Promise.reject(error);
});

Vue.use(VueAxios, axios);
